import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const createFormStyles: moduleStyleType = {
    fieldLabel: {
        display: 'block',
        marginBottom: 1,
    },
    small: {
        padding: 1,
        width: '90px',
        marginTop: 3,
    },
    big: {
        padding: 2,
        width: '200px',
    },
    realBig: {
        padding: 2,
        width: '500px',
        marginTop: 1,
    },
    iconPadding: {
        paddingLeft: '5px',
    },
    resourceDropDownItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    resourceDropDownMinWidth: {
        display: 'flex',
        minWidth: '27em',
    },
    resourceDropDownDescription: {
        color: 'text.secondary',
    },
    emergencyAccessToggle: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    emergencyAccessToggleLabel: {
        display: 'flex',
        alignItems: 'center',
    },
    emergencyAccessToggleTooltip: {
        width: '150px',
    },
    emergencyAccessIcon: {
        color: 'warning.main',
        cursor: 'pointer',
        display: 'flex',
    },
}

export const modalStyles: moduleStyleType = {
    requestIcon: {
        color: palette.success.main,
    },
}

export const CreateRequestFormStyles: moduleStyleType = {
    formContainer: {
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '6px',
        marginLeft: 0,
        marginTop: 3,
        maxWidth: '40rem',
        backgroundColor: 'background.default',
        p: 3,
    },
}
